import React from "react"
import { ImgTextCustomContainer, ImgWrapper, TextWrapper } from "./style"
import AvenueLink from "UI/AvenueLink"
import AvenueImg from "UI/AvenueImg"
import { Icon, Button } from "UI"
import parse from "html-react-parser"

const ImgTextCustom = ({ img, link, linkText, heading, message }) => {
  return (
    <ImgTextCustomContainer>
      <Icon name="ll-arrow" color="#47C5F3" width={[66, null, 90, 115]} />
      <Icon name="ll-arrow" color="#1870B0" width={[22, null, 30, 39]} />

      {img.sourceUrl && (
        <ImgWrapper>
          <AvenueImg fluid={{ ...img, sizes: "100vw" }} />
        </ImgWrapper>
      )}

      <TextWrapper>
        <h3>
          <AvenueLink to={link}>{heading}</AvenueLink>
        </h3>

        <p>{parse(message)}</p>
        <Button to={link}>{linkText}</Button>
      </TextWrapper>
    </ImgTextCustomContainer>
  )
}

export default ImgTextCustom
